import React, { useEffect } from 'react';
import { List, ListInlineItem} from 'reactstrap';
import CanvasJSReact from '@canvasjs/react-charts';
import * as Abi from '../shared/Abi';
import * as abi_token from '../shared/abi_token';
import Web3 from 'web3';
import * as helper_functions from '../services/helper_functions';

let CanvasJSChart = CanvasJSReact.CanvasJSChart;
let earnedByPools = new Map;

const POOL_LENS = "0x25E215CcE40bD849B7c286912B85212F984Ff1e0";
const POOL_REGISTRY = "0x9f7b01a536afa00ef10310a162877fd792cd0666";
const DECIMALS = 18;

function RenderPool({ poolName, tokensNameList }) {

    const tokens = tokensNameList.map((token) => {
        let srcStr = "assets/images/" + token.name.toLowerCase() + ".png";
        return (
            <ListInlineItem>
                <b><img src={srcStr} width="25" height="25" alt='' />{token.name} (${token.income}) </b>
            </ListInlineItem>
        );
    });

    return (
        <List type="inline">
            <span style={{
                        fontSize: 20,
                        marginRight : 10
                    }}> <b>{poolName}:</b></span>
            {tokens}
        </List>
    );

}

function Pools({ pools }) {
    let result;
    let results = [];
    for (let pool of pools) {
        let poolTokens = [];
        let poolIncome = 0;
        for (let token of pool[1]){
            let tokenIncome = {
                "name" : token[0],
                "income" : token[1].toFixed(0)
            }
            poolTokens.push(tokenIncome);
            poolIncome += token[1];
        }
        let poolName = pool[0] + ` ($${poolIncome.toFixed(0)})`;
        result = <RenderPool poolName={poolName} tokensNameList={poolTokens} />;
        results.push(result);
    }
    return results;
}

function IsolatedLending() {

    let [options, setoptions] = React.useState({});

    const provider = new Web3.providers.HttpProvider('https://bsc-dataseed.binance.org');
    const web3 = new Web3(provider);

    useEffect(() => {
        const init = async () => {
            const lens_address = web3.utils.toChecksumAddress(POOL_LENS);
            const lens_cnt = new web3.eth.Contract(Abi.lens_abi, lens_address);
            const all_pools = await lens_cnt.methods.getAllPools(web3.utils.toChecksumAddress(POOL_REGISTRY)).call();

            let vTokenList = [];
            let ILData = [];

            for (let pool of all_pools) {
                for (let vtoken of pool[12]) {
                    vTokenList.push(vtoken.vToken);
                }
            }

            const res = await lens_cnt.methods.vTokenUnderlyingPriceAll(vTokenList).call();
            
            for (let pool of all_pools) {
                let moneyEarned = 0;
                let earnedByTokens = new Map();
                for (let vtoken of pool[12]) {
                    let priceRow = res.filter(({ 0: n }) => n === vtoken.vToken);
                    let currunderlyingPrice = priceRow[0].underlyingPrice;
                    let currPrice = currunderlyingPrice / 10 ** (DECIMALS + DECIMALS - vtoken.underlyingDecimals);
                    let currentAmount = vtoken.totalReserves / 10 ** vtoken.underlyingDecimals;
                    moneyEarned += currPrice * currentAmount;
                    let und_cnt = new web3.eth.Contract(abi_token.lensAbi_vtoken_contract, web3.utils.toChecksumAddress(vtoken.underlyingAssetAddress));
                    let symbol  = await und_cnt.methods.symbol().call();
                    earnedByTokens.set(symbol, currPrice * currentAmount);
                }
                earnedByPools.set(pool[0], earnedByTokens);
                ILData.push({ y: moneyEarned, label: pool.name });
            }

            options = {
                animationEnabled: true,
                theme: "light2",
                title: {
                    text: "Lending income"
                },
                axisX: {
                    title: "IL Pools",
                    reversed: true,
                },
                axisY: {
                    title: "Income, USD",
                    includeZero: true,
                    labelFormatter: helper_functions.addSymbols
                },
                data: [{
                    type: "bar",
                    dataPoints: ILData
                }]
            }
            //
            setoptions(options);

        };
        init();
    }, []);

    return (
        <div className="container">
            <div className="row justify-content-center">
            <div>
                <div>
                        <CanvasJSChart options={options} />
                    </div>
                </div>
            </div>
            <div>
                <Pools pools = {earnedByPools} />
            </div>
        </div>
    );

}

export default IsolatedLending;